import { Component } from 'react'

export default class Weekday extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props !== nextProps
  }
  render() {
    const { weekday, className, weekdaysLong, weekdaysShort, localeUtils, locale } = this.props
    let title
    if (weekdaysLong) {
      title = weekdaysLong[weekday]
    } else {
      title = localeUtils.formatWeekdayLong(weekday, locale)
    }
    let content
    if (weekdaysShort) {
      content = weekdaysShort[weekday]
    } else {
      content = localeUtils.formatWeekdayShort(weekday, locale)
    }

    return (
      // biome-ignore lint/a11y/useFocusableInteractive: TODO
      // biome-ignore lint/a11y/useSemanticElements: TODO
      <div className={className} role="columnheader">
        <abbr title={title}>{content}</abbr>
      </div>
    )
  }
}
